<template>
  <div id="_speakers">
    <div class="speaker-container">
      <info-block :title="$getModuleTitle(currentEvent.modules, 'Speakers')" :desc="$t('networking.description')" :button="null" :url="null">
        <template slot="input">
          <div class="info-info">
            <el-input
              v-model="searchTerm"
              :placeholder="$t('search_in_speaker')"
              :loading="$store.state.eventLoading == 'speakers'"
              :suffix-icon="$store.state.eventLoading == 'speakers' ? 'el-icon-loading' : 'el-icon-search'"
              @clear="
                searchTerm = null;
                $store.dispatch('getSpeakers', { searchTerm: null, id: currentEvent.id, route: false });
              "
              clearable
            ></el-input>
          </div>
        </template>
      </info-block>
      <div class="speaker-search"></div>

      <Nodata
        :title="$getModuleTitle(currentEvent.modules, 'Speakers')"
        :description="categoryId == null && searchTerm == null && searchTerm != '' ? $t('contentNotFound') : $t('contentFilterNotFound')"
        anim="holacon-speakers-lottie"
        :loading="$store.state.eventLoading == 'speakers'"
        v-if="currentSpeakers.length == 0 && loading == false"
        :button="$t('refresh')"
        @btnClick="
          searchTerm = null;
          $store.dispatch('getSpeakers', { id: currentEvent.id, searchTerm: null, route: false });
        "
      />

      <transition name="fade" mode="out-in">
        <div class="speakers-grid" v-if="loading == 'loadSpeakers'">
          <el-skeleton :loading="true" class="speaker-block" animated v-for="i in 9" :key="i + '-skeleton-speakers'">
            <template slot="template">
              <div class="speaker-skeleton" :key="i + '-skeleton-key'">
                <el-skeleton-item variant="image" style="width:130px;height:130px; border-radius:50%;" />
                <div class="text-wrapper title">
                  <el-skeleton-item variant="text" style="margin-right: 16px; height:24px; width:100%" />
                </div>
                <div class="text-wrapper">
                  <el-skeleton-item variant="text" style="width: 100%; height:16px;" />
                </div>
                <div class="text-wrapper">
                  <el-skeleton-item variant="text" style="width: 50%; height:13px;" />
                </div>
                <div class="text-wrapper">
                  <el-skeleton-item variant="text" style="width: 50%; height:14px;" />
                </div>
              </div>
              <div style="padding: 14px;"></div>
            </template>
          </el-skeleton>
        </div>
        <div class="speakers-grid" v-else>
          <div @click="$store.dispatch('getSpeaker', speaker.id)" v-for="(speaker, index) in currentSpeakers" :key="index + '-speaker-block'" class="speaker-block">
            <div :style="'background-image: url(' + $imageus + speaker.image + '?width=200&height=200&mode=cover);'" class="speaker-image"></div>
            <div class="speaker-header">
              <p class="fullname">
                {{ speaker.fullName }}
              </p>
              <p class="title" v-if="speaker.title != null">
                {{ speaker.title }}
              </p>
              <p class="title" v-if="speaker.firmName != null && speaker.firmName != ''">
                <b>@ {{ speaker.firmName }}</b>
              </p>
            </div>
            <div class="bottom-line" :style="'background-color: ' + currentEvent.color"></div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import InfoBlock from "../../modules/InfoBlock.vue";
export default {
  name: "SpeakersComponent",

  data() {
    return {
      open: false,
      isMobile: false,
      searchTerm: null,
      categoryId: null,
      timeout: null,
      loading: false,
      modalVisible: false
    };
  },
  components: {
    InfoBlock
  },
  methods: {
    async searchFilter() {
      if (this.timeout != null) clearTimeout(this.timeout);

      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("getSpeakers", { searchTerm: this.searchTerm, id: this.currentEvent.id, route: false });
        this.timeout = null;
      }, 500);
    },
    openImage(speaker) {
      $.fancybox.open({
        items: [speaker.image]
      });
    }
  },
  mounted() {
    this.loading = "loadSpeakers";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.$store.dispatch("getSpeakers", { id: this.currentEvent.id, route: false });
      this.loading = false;
    }, 500);
  },
  computed: {
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    currentSpeakers() {
      return this.$store.getters.getSpeakers;
    }
  },
  watch: {
    searchTerm: function() {
      this.searchFilter();
    }
  }
};
</script>

<style lang="less">
#_speakers {
  display: flex;
  flex-direction: column;
  width: 100%;

  .speaker-container {
    display: block;
    width: inherit;
    margin: 0 auto;
    padding: 0 !important;

    .speaker-search {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      position: relative;
      margin-bottom: 20px;
    }

    .speakers-grid {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 10px;
      margin: 0px;

      .speaker-block {
        .speaker-skeleton {
          display: flex;
          flex-direction: column;
          gap: 8px;
          align-items: center;
          text-align: center;
          .text-wrapper {
            &.title {
              margin-top: 8px;
              margin-bottom: 8px;
            }
            width: 100%;
          }
        }
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 24px 16px;
        box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
        background: white;
        border-radius: 12px;
        cursor: pointer;

        &:hover {
          background-color: #fbfbfb;
          transition: all 0.3s ease 0s;
        }

        .speaker-image {
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          width: 130px;
          height: 130px;
          border-radius: 50%;
          border: 6px solid #e8ebef;
        }

        .speaker-header {
          text-align: center;
          width: 100%;

          .fullname {
            font-size: 16px;
            font-weight: 500;
            color: #292f3b;
            margin: 12px 0px 2px 0px;
          }

          .title {
            font-size: 13px;
            font-weight: 400;
            color: #505763;
            margin: 4px 0px;
          }
        }

        .bottom-line {
          width: 28%;
          height: 6px;
          border-radius: 3px;
          margin-bottom: -10px;
          margin-top: 10px;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  #_speakers {
    padding: 0px;
    .speaker-container {
      padding: 0px 12px;
      .speakers-grid {
        grid-template-columns: 1fr !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/event/Speakers.vue